import { BrowserRouter } from "react-router-dom";
import { useEffect } from "react";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n, { getEffectiveLang } from "./i18n";
import ScrollToTop from "./components/feature/ScrollToTop";

function App() {
  // Restore saved region language on app mount
  useEffect(() => {
    const saved = sessionStorage.getItem("openlab-region");
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        const effectiveLang = getEffectiveLang(parsed.lang || parsed.effectiveLang || "en");
        if (i18n.language !== effectiveLang) {
          i18n.changeLanguage(effectiveLang);
        }
      } catch {
        // ignore invalid saved data
      }
    }
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;